import { ThemeUIStyleObject } from 'theme-ui';

export const viewport: ThemeUIStyleObject = {
  bottom: 4,
};
